import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Table, Statistic, Row, Col } from 'antd';

const { Title, Paragraph } = Typography;

const Performance = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      setRows([
        { name: 'Local Awareness', impressions: 120000, clicks: 2400, ctr: '2.0%', cpc: '$0.50' },
        { name: 'Back-to-School', impressions: 220000, clicks: 4100, ctr: '1.86%', cpc: '$0.62' },
      ]);
      setLoading(false);
    }, 250);
    return () => clearTimeout(t);
  }, []);

  const columns = [
    { title: 'Campaign', dataIndex: 'name', key: 'name' },
    { title: 'Impressions', dataIndex: 'impressions', key: 'impressions' },
    { title: 'Clicks', dataIndex: 'clicks', key: 'clicks' },
    { title: 'CTR', dataIndex: 'ctr', key: 'ctr' },
    { title: 'CPC', dataIndex: 'cpc', key: 'cpc' },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Client' }, { title: 'Analytics' }, { title: 'Performance' }]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Campaign Performance</Title>
      </div>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col xs={24} md={8}><Card><Statistic title="Total Impressions" value={340000} /></Card></Col>
        <Col xs={24} md={8}><Card><Statistic title="Total Clicks" value={6500} /></Card></Col>
        <Col xs={24} md={8}><Card><Statistic title="Avg. CTR" value="1.91%" /></Card></Col>
      </Row>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>Campaign KPIs overview.</Paragraph>
        <Table rowKey="name" columns={columns} dataSource={rows} loading={loading} pagination={{ pageSize: 10 }} />
      </Card>
    </div>
  );
};

export default Performance;
